var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReconnectionCorporateService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.608,
    cy: 31.663,
    r: 3.571,
    fill: "#F6F1EA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9.877,
    r: 3.571,
    fill: "#F6F1EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.81 8.125h10.453a3 3 0 0 1 3 3V26.86",
    stroke: "url(#e2vgdnwuoa)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.909 2.645 17.145 7.37a1 1 0 0 0 0 1.42l5.075 5.034",
    stroke: "url(#qejl4fksjb)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.68 31.408c0 2.63-2.151 4.772-4.818 4.772s-4.818-2.142-4.818-4.772c0-2.63 2.151-4.773 4.818-4.773s4.818 2.142 4.818 4.773z",
    stroke: "url(#5us4p49grc)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.19 32.88H11.736a3 3 0 0 1-3-3V14.146",
    stroke: "url(#ryntxknaod)",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18.091 38.36 4.764-4.725a1 1 0 0 0 0-1.42l-5.075-5.034",
    stroke: "url(#dbizvm0z1e)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32 9.597c0-2.63 2.151-4.773 4.818-4.773s4.818 2.143 4.818 4.773-2.151 4.773-4.818 4.773S4.32 12.227 4.32 9.597z",
    stroke: "url(#3dbaftvyjf)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e2vgdnwuoa",
    x1: 27.534,
    y1: 15.007,
    x2: 20.108,
    y2: 15.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qejl4fksjb",
    x1: 20.615,
    y1: 6.752,
    x2: 17.41,
    y2: 6.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5us4p49grc",
    x1: 33.343,
    y1: 29.942,
    x2: 27.229,
    y2: 30.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ryntxknaod",
    x1: 12.466,
    y1: 25.998,
    x2: 19.892,
    y2: 25.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dbizvm0z1e",
    x1: 19.385,
    y1: 34.253,
    x2: 22.59,
    y2: 34.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3dbaftvyjf",
    x1: 6.657,
    y1: 11.063,
    x2: 12.771,
    y2: 10.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconnectionCorporateService);
export default __webpack_public_path__ + "static/media/reconnectionCorporateService.9c3fd5d812e43e6e8410beceb6170ac8.svg";
export { ForwardRef as ReactComponent };